// extracted by mini-css-extract-plugin
module.exports = {"mobileFlight__flight":"mobileFlight__flight-2cHv5","mobileFlight__segments":"mobileFlight__segments-1p1xE","mobileFlight__price":"mobileFlight__price-1trBj"};